// Factual cockpit metadata only. Operational metrics must come from hooks that
// read Agency Supabase, or render an explicit unavailable state.

export type ClientSlug = "evidens" | "tannico";

export interface ClientMeta {
  slug: ClientSlug;
  name: string;
  ticker: string;
  serviceScope: string;
  services: string[];
  analyticsStatus: "connected" | "partial";
}

export const CLIENT_META: Record<ClientSlug, ClientMeta> = {
  evidens: {
    slug: "evidens",
    name: "EviDenS de Beaute",
    ticker: "EVI",
    serviceScope: "Full stack",
    services: ["Shopify", "Meta", "Google", "Klaviyo", "SEO", "Analytics", "Strategy"],
    analyticsStatus: "connected",
  },
  tannico: {
    slug: "tannico",
    name: "Tannico",
    ticker: "TAN",
    serviceScope: "Klaviyo + analytics",
    services: ["Klaviyo", "Analytics"],
    analyticsStatus: "partial",
  },
};

export const CLIENT_LIST: ClientMeta[] = [CLIENT_META.evidens, CLIENT_META.tannico];

export const CLIENT_SLUGS = CLIENT_LIST.map((client) => client.slug);

export const KNOWLEDGE_LINKS = [
  { label: "Recent", to: "/knowledge" },
  { label: "Decisions", to: "/knowledge?kind=decision" },
  { label: "Meetings", to: "/knowledge?kind=meeting" },
  { label: "Client briefs", to: "/knowledge?query=brief" },
];
